__turbopack_context__.v({
  "changeStrapButton": "ChangeStrapButton-module-scss-module__Pa6xDq__changeStrapButton",
  "chevron": "ChangeStrapButton-module-scss-module__Pa6xDq__chevron",
  "imageContainer": "ChangeStrapButton-module-scss-module__Pa6xDq__imageContainer",
  "label": "ChangeStrapButton-module-scss-module__Pa6xDq__label",
  "strapImage": "ChangeStrapButton-module-scss-module__Pa6xDq__strapImage",
});
